<template>
  <div class="btn" :style="`justify-content: ${justifyContent}`">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BottomBtn',
  props: {
    justifyContent: {
      type: String,
      default: 'center'
    }
  }
}
</script>

<style lang="less" scoped>
.btn {
  display: flex;
  // justify-content: center;
  align-items: center;
  height: 72px;
  background: #ffffff;
  box-shadow: inset 0px 1px 0px 0px #e5e6eb;
  flex-shrink: 0;
}
</style>
